function useWebEngageTaraLoginDone() {
  const trackWebEngageTaraLoginDone = () => {
    try {
      window.webengage.track("Tara Login Done");
    } catch (error) {
      console.log("🚀 ~ Tara Login Done ~ error:", error);
    }
  };

  return { trackWebEngageTaraLoginDone };
}

export default useWebEngageTaraLoginDone;
